export default "__VITE_ASSET__DEJs5Ims__"